import {AppFunction} from "../misc/types";
import View from "../framework/view";
import {BackupView} from "../views/backup";

export class BackupFunction extends AppFunction {

    readonly v : View;

    constructor() {
        super();
        this.v = new BackupView();
    }

    view() {
        return this.v;
    }

    url() {
        return `/backup`;
    }
}
